import { useEffect, useRef, useState } from 'react';

export default function CallToAction() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section ref={sectionRef} className="py-24 px-6 bg-white">
      <div className="container mx-auto max-w-5xl">
        <div className={`relative bg-gradient-to-br from-purple-600 via-purple-500 to-rose-500 rounded-3xl overflow-hidden shadow-2xl transition-all duration-1000 transform ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-rose-400/20 rounded-full blur-3xl"></div>
          
          <div className="relative z-10 py-20 px-8 md:px-16 text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              Let's Create Something Impactful Together
            </h2>
            <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto" style={{ fontFamily: '"Lora", serif' }}>
              Reach out if you want to create something impactful together.
            </p>
            <button 
              onClick={scrollToContact}
              className="group inline-flex items-center justify-center px-10 py-4 text-lg font-semibold text-purple-600 bg-white rounded-full hover:bg-gray-50 transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <span>Contact Me</span>
              <i className="ri-arrow-right-line ml-2 text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
